// SHA-256 of the normalized (trimmed, lowercased) email, hex-encoded. Marketing
// tags in the GTM container must receive the hash instead of the raw address
// (privacy requirement); Web Crypto is async, so GTMProvider chains its
// dataLayer pushes on the cached promise.
let cached: { email: string; promise: Promise<string | null> } | null = null;

async function sha256Hex(input: string): Promise<string | null> {
  try {
    const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(input));
    return Array.from(new Uint8Array(digest))
      .map((byte) => byte.toString(16).padStart(2, '0'))
      .join('');
  } catch (_e) {
    // Non-secure context or a browser without Web Crypto — send nothing.
    return null;
  }
}

export function getHashedEmail(email?: string): Promise<string | null> {
  if (!email) return Promise.resolve(null);
  const normalized = email.trim().toLowerCase();
  if (cached?.email !== normalized) {
    cached = { email: normalized, promise: sha256Hex(normalized) };
  }
  return cached.promise;
}
